import React from 'react'

import UI5MenuItem from "../../menu/ui5-menu/ui5-menu-item"
import {useEntitySelectorContext} from "../context"
import {EntitySelectorEntityType, EntitySelectorMenuItem} from "../@const"

type Props = {
    menuItems           : EntitySelectorMenuItem[]
    currentEntityType   : EntitySelectorEntityType

    onSelect            : {(id: EntitySelectorEntityType): void}
}

const debug = false
// const debug = "EntitySelectorMenu"

// The left column: which KIND of thing is being picked.
//
// Stock `ui5-menu` rows, the same component the info-view sidebars use -- the
// selected state (pale blue plate, blue label and glyph) comes from the skin,
// so there is nothing to style here.
export function EntitySelectorMenu(props: Props) {
    const context = useEntitySelectorContext()

    debug && console.log(debug, 'render', props.currentEntityType)

    // The heading is host chrome: a mode without a title row never shows one,
    // however the host was called.
    const title = context.config.hasTitleRow ? context.title : null

    // Under a heading the rows need no top inset -- the heading's box already is
    // one. With no heading (the mention popover) they carry it themselves, and
    // it has to be a class and not a rule in selector.scss: the `p-t-0` it would
    // be overriding is a helper, and helpers are `!important`.
    const menuClasses = Classes("ui5-menu w-100-percent", title ? "p-t-0" : "p-t-15")

    return (
        <div className="entity-selector-menu flex-column-left-top flex-no-shrink">
            {/* the same header box the content column uses, so the two titles
                sit on one line instead of on two paddings that nearly agree */}
            {!!title &&
                <div className="entity-selector-header flex-row-left-center flex-no-shrink w-100-percent">
                    <div className="ui5-title-app-name txt-truncate">{title}</div>
                </div>}

            <div className={menuClasses}>
                {_.map(props.menuItems, (menuItem: EntitySelectorMenuItem) => {
                    return (
                        <UI5MenuItem
                            key         = {menuItem.id}
                            item        = {menuItem}
                            selectedId  = {props.currentEntityType}
                            onClick     = {props.onSelect}
                        />
                    )
                })}
            </div>
        </div>
    )
}
